
<app-drag-handle />

<article class="points__all-transport-list"> 
  <app-header 
    [previousPointTitle]="getPreviousPointTitle()"
    [currentPointTitle]="getPointTitle()"
  />
  
  <hr class="all-transport-list__divider">

  <app-main 
    [transportList]="getTransportList()"
    [transportId]="getTransportId()"
  />
  
  <app-footer />
</article>

